import { render, staticRenderFns } from "./Servicing.vue?vue&type=template&id=0ceba578&"
import script from "./Servicing.vue?vue&type=script&lang=js&"
export * from "./Servicing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports